<app-template>


  <app-base-edit *ngIf="data"  [editConfig]="editConfig" [item]="data" (action)="onAction($event.name, $event.data)"></app-base-edit>

</app-template>
